import React, { useEffect } from 'react';
import tokenHelper from '../../helpers/tokenHelper';

const WebSocketComponent = ({ userId }: { userId: string }) => {
    useEffect(() => {
        const socket = new WebSocket('wss://resetpilates.rs/ws/');

        socket.onopen = () => {
            console.log('WebSocket connected');
            // Autentifikacija ISKLJUCIVO potpisanim JWT-om (server ne veruje
            // prosledjenom userId-u). Bez tokena - ne autentikuj se.
            const token = tokenHelper.getToken();
            if (token) {
                socket.send(JSON.stringify({ type: 'authenticate', token }));
            }
        };

        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log('Message received:', data.message);
        };

        socket.onclose = () => {
            console.log('WebSocket disconnected');
        };

        return () => {
            socket.close();
        };
    }, [userId]);
    return <></>
    // return <div>WebSocket active for user: {userId}</div>;
};

export default WebSocketComponent;
